export default __webpack_public_path__ + "static/media/jumboIllustrations.8307f77a.svg";